import { useSelector } from 'react-redux';
import { getCurrentUser } from 'store/profile';

export const useCurrentUser = () => {
  return useSelector(getCurrentUser);
};
